/*
 * Terms of Service gate — see snippets/tos-gate.liquid.
 * One consent value per browser session, mirrored to every gate on the page.
 */
(function () {
  var KEY = 'tst_tos_agreed_session';
  var ERROR_TEXT = 'Please tick the box to agree to the Terms of Service before checking out.';

  function agreed() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function store(value) {
    try {
      if (value) sessionStorage.setItem(KEY, '1');
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
  }

  function sync(value) {
    document.querySelectorAll('[data-tos-checkbox]').forEach(function (cb) { cb.checked = value; });
    document.querySelectorAll('[data-tos-gate]').forEach(function (gate) {
      gate.classList.toggle('is-agreed', value);
      var buttons = gate.querySelector('[data-tos-buttons]');
      if (buttons) {
        if (value) buttons.removeAttribute('inert');
        else buttons.setAttribute('inert', '');
      }
      if (value) {
        gate.classList.remove('has-error');
        var err = gate.querySelector('[data-tos-error]');
        if (err) err.textContent = '';
      }
    });
  }

  function showError(gate) {
    if (!gate) return;
    var err = gate.querySelector('[data-tos-error]');
    if (err) err.textContent = ERROR_TEXT;
    gate.classList.remove('has-error');
    void gate.offsetWidth; // restart the shake animation on repeat taps
    gate.classList.add('has-error');
    var box = gate.querySelector('.tos-gate__box');
    if (box && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var cb = gate.querySelector('[data-tos-checkbox]');
    if (cb) cb.focus({ preventScroll: true });
  }

  window.TopshotTos = {
    agreed: agreed,
    // Returns true if checkout may continue; otherwise shows the error on that gate.
    require: function (gateOrChild) {
      var gate = gateOrChild && gateOrChild.closest ? gateOrChild.closest('[data-tos-gate]') : null;
      if (agreed()) return true;
      showError(gate || document.querySelector('[data-tos-gate]'));
      return false;
    }
  };

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-tos-checkbox]')) return;
    store(e.target.checked);
    sync(e.target.checked);
  });

  // Capture phase so the shield wins even if something else listens for clicks.
  document.addEventListener('click', function (e) {
    var shield = e.target.closest && e.target.closest('[data-tos-shield]');
    if (!shield) return;
    e.preventDefault();
    e.stopPropagation();
    showError(shield.closest('[data-tos-gate]'));
  }, true);

  function init() { sync(agreed()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Back/forward cache restores the page without re-running scripts.
  window.addEventListener('pageshow', init);
})();
